import React from "react";

/** Renders the tools card comopnent on Landing page */
const ToolsCard = ({
    src = "",
    title = "",
    shortDescription = "",
    alt = "",
}) => {
    return (
        <div className="col-sm-12 col-md-3 mb-3">
            <div className="card h-100 mb-3">
                <img className="card-img-top" src={src} alt={alt} />
                <div className="card-body">
                    <h5 className="card-title">{title}</h5>
                    <p className="card-text">{shortDescription}</p>
                </div>
            </div>
        </div>
    );
};

export default ToolsCard;
